import React, { useEffect, useState } from 'react'
import { Button, Col, Form, Input, List, Modal, Popconfirm, Row, Select, Spin, Upload, message, notification, Radio, Divider } from 'antd';

import {
    PlusOutlined,
    DeleteOutlined,
    ExclamationCircleFilled
} from '@ant-design/icons';


import image from '../../1695793881259.jpeg'
import TextArea from 'antd/es/input/TextArea';

// Quill
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import 'react-quill/dist/quill.bubble.css';

import './style.scss';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { useSelector } from 'react-redux';
import history from '../../../../../../history';
import { deleteCourse, deleteCourseContent, editCourse, getAllUsers, getCourseById, getCourseContentByRoleAndCourseId } from '../../../../../Constants/Api/functions/function';
import AddContent from './AddContent';
import EditContent from './EditContent';
import { formatDriveUrl } from '../../../../../Utils/driveUtils';
import { UPLOAD_COURSE_THUMBNAIL_URL } from '../../../../../Constants/Api/azure/azure';

const { Option } = Select;

const modules = {
    toolbar: [
        [{ font: [] }],
        [{ header: [1, 2, 3, 4, 5, 6, false] }],
        [{ align: [] }],
        ["bold", "italic", "underline", "strike"],
        [{ color: [] }, { background: [] }],
        [{ script: "sub" }, { script: "super" }],
        ["blockquote", "code-block"],
        [{ list: "ordered" }, { list: "bullet" }],
        ["link", "image", "video"],
        ["clean"],
    ],
};

const EditCourse = () => {
    const [api, contextHolder] = notification.useNotification();
    const [form] = Form.useForm();
    const [isLoading, setIsLoading] = useState(false);
    const [selectedContentId, setSelectedContentId] = useState();
    const [selectedContentData, setSelectedContentData] = useState();
    const [openEdit, setOpenEdit] = useState(false);
    const [isAddContentOpen, setisAddContentOpen] = useState(false);
    const [courseData, setCourseData] = useState();
    const [data, setData] = useState();
    const courseId = useParams().id
    const userProfile = useSelector(state => state.userProfile.userProfile);
    const allCources = useSelector(state => state.allCources.allCources);
    const { confirm } = Modal;
    const [fileList, setFileList] = useState([]);
    const [isCoverImageChanged, setIsCoverImageChanged] = useState(false);
    const [installmentCount, setInstallmentCount] = useState(0);
    const [alumniInstallmentCount, setAlumniInstallmentCount] = useState(0);
    const [instructors, setInstructors] = useState([]);
    const [coordinators, setCoordinators] = useState([]);

    useEffect(() => {
        const fetchInstructors = async () => {
            try {
                const users = await getAllUsers(2); // Center 2
                if (users) {
                    const filtered = users.filter(u => u.role === 'instructor');
                    setInstructors(filtered);
                    setCoordinators(users.filter(u => u.role === 'coordinator'));
                }
            } catch (error) {
                console.error("Failed fetching instructors:", error);
            }
        };
        fetchInstructors();
    }, []);

    useEffect(() => {
        if (userProfile) {
            const isAdmin = userProfile.role === 'superadmin' || userProfile.role === 'admin';
            const isInstructor = userProfile.role === 'instructor';
            const isCoordinator = userProfile.role === 'coordinator';
            
            if (isInstructor) {
                if (courseData) {
                    if (!courseData.instructorId || !userProfile.id || String(courseData.instructorId) !== String(userProfile.id)) {
                        history.push('/dashboard/home');
                    }
                }
            } else if (isCoordinator) {
                if (courseData) {
                    if (!courseData.coordinatorId || !userProfile.id || String(courseData.coordinatorId) !== String(userProfile.id)) {
                        history.push('/dashboard/home');
                    }
                }
            } else if (!isAdmin) {
                history.push('/dashboard/home');
            }
        }
    }, [userProfile, courseData]);

    useEffect(() => {
        if (allCources?.length > 0) {
            const course = allCources.find(course => course.id === courseId);
            setCourseData(prev => {
                if (prev?.id === course?.id && prev?.installmentBreakdown) {
                    return prev;
                }
                return course;
            });
        }
    }, [allCources, courseId]);

    useEffect(() => {
        handelGetCourseById();
    }, [courseId]);

    useEffect(() => {
        getCourseContents();
    }, [courseData]);

    useEffect(() => {
        const content = data?.find(content => content.id === selectedContentId);
        setSelectedContentData(content);
    }, [selectedContentId]);

    useEffect(() => {
        if (courseData) {
            const breakdown = courseData.installmentBreakdown || [];
            const count = courseData.installments || 0;
            const installmentAmounts = Array.from({ length: count }, (_, index) => {
                const match = breakdown.find(item => item.installmentNumber === index + 1);
                return match ? match.amount : undefined;
            });
            const installmentDueDate = Array.from({ length: count }, (_, index) => {
                const match = breakdown.find(item => item.installmentNumber === index + 1);
                return match && match.dueDate ? match.dueDate.split('T')[0] : undefined;
            });

            const alumniBreakdown = courseData.alumniInstallmentBreakdown || [];
            // Alumni amounts are mapped to the same rows as standard installments (by installmentNumber)
            const alumniInstallmentAmounts = Array.from({ length: count }, (_, index) => {
                const match = alumniBreakdown.find(item => item.installmentNumber === index + 1);
                return match ? match.amount : undefined;
            });

            setInstallmentCount(count);

            form.setFieldsValue({
                courseid: courseData.courseid,
                name: courseData.name,
                description: courseData.description,
                coverImage: courseData.coverImage,
                isPublished: courseData.isPublished ? 'true' : 'false',
                isAppearOnHome: courseData.isAppearOnHome ? 'true' : 'false',
                price: courseData.price,
                orderNumber: courseData.orderNumber,
                tags: courseData.tags?.split(','),
                startDate: courseData.startDate,
                startTime: courseData.startTime,
                installments: courseData.installments,
                isShowOnHome: courseData.isShowOnHome ? 'true' : 'false',
                description1: courseData.description1,
                whatsappGroupLink: courseData.whatsappGroupLink,
                videoUrl: courseData.videoUrl,
                coordinatorId: courseData.coordinatorId || undefined,
                coordinatorName: courseData.coordinatorName,
                coordinatorWhatsApp: courseData.coordinatorWhatsApp,
                duration: courseData.duration,
                promoPrice: courseData.promoPrice,
                promoStartDate: courseData.promoStartDate ? courseData.promoStartDate.split('T')[0] : undefined,
                promoEndDate: courseData.promoEndDate ? courseData.promoEndDate.split('T')[0] : undefined,
                isPromoActive: courseData.isPromoActive ? true : false,
                status: courseData.status === 'completed' ? 'completed' : 'ongoing',
                installmentAmounts: installmentAmounts.length > 0 ? installmentAmounts : [],
                installmentDueDate: installmentDueDate.length > 0 ? installmentDueDate : [],
                instructorIds: courseData.instructorIds || [],
                prerequisiteCourseIds: courseData.prerequisiteCourseIds ? JSON.parse(courseData.prerequisiteCourseIds) : [],
                alumniDiscount: courseData.alumniDiscount || 0,
                alumniInstallmentAmounts: alumniInstallmentAmounts.length > 0 ? alumniInstallmentAmounts : [],
            });

            setFileList([{
                uid: '-1',
                name: 'image.png',
                status: 'done',
                url: courseData.coverImage,
            }]);
        }
    }, [courseData, form]);

    const handleInstallmentCountChange = (event) => {
        const value = parseInt(event?.target?.value, 10);
        if (Number.isNaN(value) || value <= 0) {
            setInstallmentCount(0);
            form.setFieldsValue({ installmentAmounts: [], installmentDueDate: [] });
            return;
        }
        setInstallmentCount(value);
    };

    const handleAlumniInstallmentCountChange = (event) => {
        const value = parseInt(event?.target?.value, 10);
        if (Number.isNaN(value) || value <= 0) {
            setAlumniInstallmentCount(0);
            form.setFieldsValue({ alumniInstallmentAmounts: [], alumniInstallmentDueDate: [] });
            return;
        }
        setAlumniInstallmentCount(value);
    };

    const showAddContent = () => {
        setisAddContentOpen(true);
    };

    const onFinish = async (values) => {
        setIsLoading(true);

        Object.keys(values).forEach(key => (values[key] === undefined || values[key] === '') && delete values[key]);

        values.id = courseId;

        if (values.isPublished === 'true') {
            values.isPublished = true;
        } else {
            values.isPublished = false;
        }

        if (values.isAppearOnHome === 'true') {
            values.isAppearOnHome = true;
        } else {
            values.isAppearOnHome = false;
        }

        if (values.isShowOnHome === 'true') {
            values.isShowOnHome = true;
        } else if (values.isShowOnHome === 'false') {
            values.isShowOnHome = false;
        }

        if (values.isPromoActive === true || values.isPromoActive === 'true') {
            values.isPromoActive = true;
        } else {
            values.isPromoActive = false;
        }

        if (values.tags) {
            values.tags = values.tags.join(',');
        }

        if (values.installments !== undefined) {
            values.installments = Number(values.installments) || 0;
        }

        if (values.installments > 0) {
            const normalizedInstallments = (values.installmentAmounts || [])
                .slice(0, values.installments)
                .map((amount, index) => ({
                    installmentNumber: index + 1,
                    amount: Number(amount) || 0,
                    dueDate: values.installmentDueDate && values.installmentDueDate[index] ? values.installmentDueDate[index] : null
                }));
            values.installmentAmounts = normalizedInstallments;
        } else {
            values.installmentAmounts = [];
        }

        if (values.alumniInstallmentAmounts && values.installments > 0) {
            const normalizedAlumniInstallments = (values.alumniInstallmentAmounts || [])
                .slice(0, values.installments)
                .map((amount, index) => ({
                    installmentNumber: index + 1,
                    amount: Number(amount) || 0,
                    dueDate: values.installmentDueDate && values.installmentDueDate[index] ? values.installmentDueDate[index] : null
                }))
                .filter(inst => inst.amount > 0);
            values.alumniInstallmentAmounts = normalizedAlumniInstallments;
            values.alumniInstallments = normalizedAlumniInstallments.length;
        } else {
            values.alumniInstallmentAmounts = [];
            values.alumniInstallments = 0;
        }

        if (isCoverImageChanged) {
            if (fileList.length < 1) {
                openEditNotification('error',
                    'Upload course cover image',
                    'Please upload course cover image to continue'
                );
                return;
            }

            const blobName = `${values.name.replace(/\s/g, '')}`;  // used as file basename
            const res = await uploadFile(blobName);
            if (!res || !res.url) {
                openEditNotification('error', 'Upload failed', 'Failed to upload course cover image. Please try again.');
                setIsLoading(false);
                return;
            }
            values.coverImage = res.url;
        }

        try {
            const res = await editCourse(values);
            if (res && res.status === 200) {
                openEditNotification('success',
                    'Course updated successfully',
                    'The course has been updated successfully'
                );
                handelGetCourseById();
            } else {
                openEditNotification('error',
                    'Course update failed',
                    'The course update failed'
                );
            }
        }
        catch (error) {
            console.error('editCourse', error);
        }

        setIsLoading(false);
    }

    const uploadFile = async (baseName) => {
        try {
            const formData = new FormData();
            formData.append('image', fileList[0].originFileObj);
            formData.append('fileName', baseName);

            const response = await fetch(UPLOAD_COURSE_THUMBNAIL_URL, {
                method: 'POST',
                body: formData,
            });

            const data = await response.json();
            if (!data.success) {
                throw new Error(data.message || 'Upload failed');
            }
            return data;
        } catch (error) {
            console.error('uploadFile error:', error);
            return null;
        }
    }

    const deleteContent = async (id) => {
        setIsLoading(true);
        try {
            const response = await deleteCourseContent(id);
            if (response && response.status === 200) {
                openDeleteNotification('success',
                    'Course content deleted successfully',
                    'The course content has been deleted successfully'
                );
                await getCourseContents();
            } else {
                openDeleteNotification('error',
                    'Course content deletion failed',
                    'The course content deletion failed'
                );
            }
        } catch (error) {
            console.error('deleteCourse', error);
            openDeleteNotification('error',
                'Course content deletion failed',
                `The course content deletion failed. ${error}`
            );
        }
        setIsLoading(false);
    }

    const handelGetCourseById = async () => {
        try {
            const response = await getCourseById(courseId);
            const normalizedCourse = Array.isArray(response) ? response[0] : response;
            setCourseData(prev => {
                if (!prev) {
                    return normalizedCourse;
                }
                if (prev.id === normalizedCourse?.id) {
                    return { ...prev, ...normalizedCourse };
                }
                return normalizedCourse;
            });
        } catch (error) {
            console.error('handelGetCourseById', error);
        }
    }

    const getCourseContents = async () => {
        setIsLoading(true);
        try {
            const response = await getCourseContentByRoleAndCourseId(courseId, userProfile.role, userProfile.id);
            if (response) {
                setData(response.map((item) => {
                    return {
                        id: item.id,
                        title: item.title,
                        description: item.description,
                        createdAt: item.createdAt,
                        videoUrl: item.videoUrl,
                        driveUrl: item.driveUrl,
                        isPublished: item.isPublished,
                        isFree: item.isFree,
                        installment: item.installment,
                        courseId: item.courseId,
                    }
                }))

                if (response.length > 0) {
                setSelectedContentId(response[0].id);
                }
            }
        } catch (error) {
            console.error('getCourseContents', error);
        }
        setIsLoading(false);
    }

    const handleDeleteCourse = async () => {
        setIsLoading(true);
        try {
            const response = await deleteCourse(courseId);
            if (response && response.status === 200) {
                openDeleteNotification('success',
                    'Course deleted successfully',
                    'The course has been deleted successfully'
                );

                setTimeout(() => {
                    history.push('/dashboard/cources');
                }, 2000);

            } else {
                openDeleteNotification('error',
                    'Course deletion failed',
                    'The course deletion failed'
                );
            }
        } catch (error) {
            console.error('deleteCourse', error);
            openDeleteNotification('error',
                'Course deletion failed',
                `The course deletion failed. ${error}`
            );
        }
        setIsLoading(false);
    }

    const showDeleteConfirm = async () => {
        confirm({
            title: 'Are you sure delete this course?',
            icon: <ExclamationCircleFilled />,
            content: 'This action cannot be undone. Are you sure you want to delete this course? If you delete this course, all the contents of this course will be deleted.',
            okText: 'Yes',
            okType: 'danger',
            cancelText: 'No',
            onOk: async () => {
                await handleDeleteCourse(courseId);
            },
        });
    };

    const openDeleteNotification = (type, message, description) => {
        api[type]({
            message: message,
            description: description,
        });
    }

    const openEditNotification = (type, message, description) => {
        api[type]({
            message: message,
            description: description,
        });
    }

    const onChange = ({ fileList: newFileList }) => {
        setFileList(newFileList);
        setIsCoverImageChanged(true);
    };
    const onPreview = async (file) => {
        let src = file.url;
        if (!src) {
            src = await new Promise((resolve) => {
                const reader = new FileReader();
                reader.readAsDataURL(file.originFileObj);
                reader.onload = () => resolve(reader.result);
            });
        }
        const image = new Image();
        image.src = src;
        const imgWindow = window.open(src);
        imgWindow?.document.write(image.outerHTML);
    };

    return (
        <div className='edit-course'>
            <Spin spinning={isLoading}
                size="large"
                tip="Loading..."
            >
                {contextHolder}
                <div className='edit-header'>
                    <h1>Edit Course</h1>
                    {userProfile?.role !== 'instructor' && userProfile?.role !== 'coordinator' && (
                        <Button
                            type='primary'
                            danger
                            className='btn'
                            onClick={showDeleteConfirm}
                        >
                            <DeleteOutlined />
                            <span>Delete Course</span>
                        </Button>
                    )}
                </div>
                <div className='edit-body'>
                    {userProfile?.role !== 'coordinator' && (
                    <div className='edit-left'>
                        <div className='thumbnail'>
                            <img
                                src={courseData?.coverImage || image}
                                alt='thumbnail' />
                        </div>
                        <div className='edit-course'
                            style={{
                                marginTop: '20px'
                            }}
                        >
                            <Form
                                layout="vertical"
                                onFinish={onFinish}
                                form={form}
                            >
                                <Form.Item
                                    name="courseid"
                                    label="Course ID"
                                >
                                    <Input
                                        showCount
                                        maxLength={200}
                                        placeholder="Please enter course ID" />
                                </Form.Item>
                                <Form.Item
                                    name="name"
                                    label="Course Name"
                                >
                                    <Input
                                        showCount
                                        maxLength={200}
                                        placeholder="Please enter course's name" />
                                </Form.Item>
                                <Form.Item
                                    name="instructorIds"
                                    label="Assign Instructors"
                                >
                                    <Select
                                        mode="multiple"
                                        placeholder="Select instructors to assign to this course"
                                        allowClear
                                        showSearch
                                        optionFilterProp="children"
                                        disabled={userProfile?.role === 'instructor'}
                                    >
                                        {instructors.map(inst => (
                                            <Option key={inst.id} value={inst.id}>
                                                {inst.name} ({inst.email})
                                            </Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                                <Form.Item
                                    name="description"
                                    label="Course Description"
                                >
                                    <ReactQuill
                                        modules={modules}
                                        theme="snow"
                                        placeholder="Please enter course's description"
                                        style={{ height: '200px', marginBottom: '50px' }}
                                    />
                                </Form.Item>
                                
                                <Form.Item
                                    name="orderNumber"
                                    label="Order Number (The order of the course when displaying)"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please enter course's order number",
                                        },
                                    ]}
                                >
                                    <Input
                                        type="number"
                                        placeholder="Please enter course's order number" />
                                </Form.Item>

                                <Form.Item
                                    name="tags"
                                    label="Select course tags"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please select course's tags",
                                        },
                                    ]}
                                >
                                    <Select
                                        mode="multiple"
                                        allowClear
                                        style={{
                                            width: '100%',
                                        }}
                                        placeholder="Please select"
                                        options={[
                                            // Base Tags
                                            { label: 'Video Tutorials', value: 'VideoTutorials' },
                                            { label: 'Exams', value: 'Exams' },
                                            { label: 'Training and Courses', value: 'TrainingAndCourses' },
                                            { label: 'News', value: 'News' },
                                            { label: 'Seminar', value: 'Seminar' },

                                            // Management
                                            { label: 'Category: Management', value: 'Management' },
                                            { label: '→ Business Management', value: 'Business Management' },
                                            { label: '→ Human Resource Management', value: 'Human Resource Management' },
                                            { label: '→ Entrepreneurship', value: 'Entrepreneurship' },
                                            { label: '→ Project Management', value: 'Project Management' },
                                            { label: '→ Office Administration', value: 'Office Administration' },

                                            // Accounting & Finance
                                            { label: 'Category: Accounting & Finance', value: 'Accounting & Finance' },
                                            { label: '→ Diploma in Accounting', value: 'Diploma in Accounting' },
                                            { label: '→ QuickBooks Accounting', value: 'QuickBooks Accounting' },
                                            { label: '→ Computerized Accounting', value: 'Computerized Accounting' },
                                            { label: '→ Taxation', value: 'Taxation' },
                                            { label: '→ Auditing', value: 'Auditing' },
                                            { label: '→ Financial Management', value: 'Financial Management' },

                                            // Data Analytics & IT
                                            { label: 'Category: Data Analytics & IT', value: 'Data Analytics & IT' },
                                            { label: '→ Advanced Excel', value: 'Advanced Excel' },
                                            { label: '→ Power BI', value: 'Power BI' },
                                            { label: '→ Data Analytics', value: 'Data Analytics' },
                                            { label: '→ Dashboard Reporting', value: 'Dashboard Reporting' },
                                            { label: '→ Business Intelligence', value: 'Business Intelligence' },

                                            // Artificial Intelligence (AI)
                                            { label: 'Category: Artificial Intelligence (AI)', value: 'Artificial Intelligence (AI)' },
                                            { label: '→ AI for Business', value: 'AI for Business' },
                                            { label: '→ ChatGPT & AI Tools', value: 'ChatGPT & AI Tools' },
                                            { label: '→ Prompt Engineering', value: 'Prompt Engineering' },
                                            { label: '→ AI Productivity', value: 'AI Productivity' },
                                            { label: '→ AI for Marketing', value: 'AI for Marketing' },

                                            // Logistics & Supply Chain
                                            { label: 'Category: Logistics & Supply Chain', value: 'Logistics & Supply Chain' },
                                            { label: '→ Logistics Management', value: 'Logistics Management' },
                                            { label: '→ Warehouse Management', value: 'Warehouse Management' },
                                            { label: '→ Shipping Management', value: 'Shipping Management' },
                                            { label: '→ Procurement Management', value: 'Procurement Management' },

                                            // Graphic Design & Multimedia
                                            { label: 'Category: Graphic Design & Multimedia', value: 'Graphic Design & Multimedia' },
                                            { label: '→ Graphic Design', value: 'Graphic Design' },
                                            { label: '→ Photoshop', value: 'Photoshop' },
                                            { label: '→ Illustrator', value: 'Illustrator' },
                                            { label: '→ Canva Design', value: 'Canva Design' },
                                            { label: '→ Video Editing', value: 'Video Editing' },

                                            // Architecture & Design
                                            { label: 'Category: Architecture & Design', value: 'Architecture & Design' },
                                            { label: '→ AutoCAD', value: 'AutoCAD' },
                                            { label: '→ Architectural Design', value: 'Architectural Design' },
                                            { label: '→ Interior Design', value: 'Interior Design' },
                                            { label: '→ 3D Visualization', value: '3D Visualization' },

                                            // Professional Exam Classes
                                            { label: 'Category: Professional Exam Classes', value: 'Professional Exam Classes' },
                                            { label: '→ Association of Accounting Technicians of Sri Lanka (AAT)', value: 'Association of Accounting Technicians of Sri Lanka (AAT)' },
                                            { label: '→ Chartered Accounting', value: 'Chartered Accounting' },
                                            { label: '→ Sri Lanka Institute of Marketing (SLIM)', value: 'Sri Lanka Institute of Marketing (SLIM)' },
                                            { label: '→ Professional Business Qualifications', value: 'Professional Business Qualifications' }
                                        ]}
                                    />
                                </Form.Item>

                                <Form.Item
                                    name="coverImage"
                                    label="Course cover image"
                                >
                                    <Upload
                                        action="https://660d2bd96ddfa2943b33731c.mockapi.io/api/upload"
                                        listType="picture-card"
                                        fileList={fileList}
                                        onChange={onChange}
                                        onPreview={onPreview}
                                        beforeUpload={file => {
                                            const isPNG = (file.type === 'image/png' || file.type === 'image/jpeg' || file.type === 'image/jpg');
                                            if (!isPNG) {
                                                message.error(`${file.name} is not a png file`);

                                                return isPNG || Upload.LIST_IGNORE;
                                            } else {
                                                return false;
                                            }
                                        }}
                                    >
                                        {fileList.length < 1 && '+ Upload'}
                                    </Upload>
                                </Form.Item>

                                <Form.Item
                                    name='startDate'
                                    label="Course Start Date"
                                >
                                    <Input
                                        type="date"
                                        placeholder="Please enter course's start date" />
                                </Form.Item>

                                <Form.Item
                                    name='duration'
                                    label="Course Duration"
                                >
                                    <Input
                                        placeholder="Please enter course's duration (e.g. 6 Months, 3 Weeks)" />
                                </Form.Item>

                                <Form.Item
                                    name='startTime'
                                    label="Course Start Time"
                                >
                                    <Input
                                        type="time"
                                        placeholder='Please enter course start time'
                                    />
                                </Form.Item>

                                <Form.Item
                                    name="price"
                                    label="Standard Course Price (LKR)"
                                >
                                    <Input
                                        type="number"
                                        placeholder="Please enter course's standard price" />
                                </Form.Item>

                                <Form.Item name="isPromoActive" label="Promotional Pricing Active" initialValue={false}>
                                    <Radio.Group>
                                        <Radio value={true}>Yes</Radio>
                                        <Radio value={false}>No</Radio>
                                    </Radio.Group>
                                </Form.Item>

                                <Form.Item name="promoPrice" label="Promotional Price (LKR)">
                                    <Input type="number" placeholder="Enter promo price" />
                                </Form.Item>

                                <Form.Item name="promoStartDate" label="Promo Start Date">
                                    <Input type="date" />
                                </Form.Item>

                                <Form.Item name="promoEndDate" label="Promo End Date">
                                    <Input type="date" />
                                </Form.Item>

                                <Form.Item name="prerequisiteCourseIds" label="Prerequisite/Alumni Courses">
                                    <Select mode="multiple" placeholder="Select courses that grant alumni discount">
                                        {allCources?.map(c => (
                                            <Option key={c.id} value={c.id}>{c.name}</Option>
                                        ))}
                                    </Select>
                                </Form.Item>

                                <Form.Item name="alumniDiscount" label="Alumni Discount Amount (LKR)">
                                    <Input type="number" placeholder="Enter discount amount for alumni" />
                                </Form.Item>

                                <Form.Item
                                    name='installments'
                                    label="Number of Installments"
                                >
                                    <Input
                                        type="number"
                                        min={0}
                                        placeholder='Please enter number of installments'
                                        onChange={handleInstallmentCountChange}
                                    />
                                </Form.Item>

                                {installmentCount > 0 && (
                                    <div style={{ overflowX: 'auto', marginBottom: 16 }}>
                                        <table style={{ width: '100%', borderCollapse: 'collapse', border: '1px solid #f0f0f0' }}>
                                            <thead>
                                                <tr style={{ background: '#fafafa' }}>
                                                    <th style={{ padding: '10px 12px', borderBottom: '1px solid #f0f0f0', textAlign: 'left', fontWeight: 600, fontSize: 13 }}>#</th>
                                                    <th style={{ padding: '10px 12px', borderBottom: '1px solid #f0f0f0', textAlign: 'left', fontWeight: 600, fontSize: 13 }}>Standard Amount (LKR)</th>
                                                    <th style={{ padding: '10px 12px', borderBottom: '1px solid #f0f0f0', textAlign: 'left', fontWeight: 600, fontSize: 13 }}>Alumni Amount (LKR)</th>
                                                    <th style={{ padding: '10px 12px', borderBottom: '1px solid #f0f0f0', textAlign: 'left', fontWeight: 600, fontSize: 13 }}>Due Date</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {Array.from({ length: installmentCount }).map((_, index) => (
                                                    <tr key={`installment-row-${index}`} style={{ borderBottom: '1px solid #f0f0f0' }}>
                                                        <td style={{ padding: '8px 12px', verticalAlign: 'top', fontWeight: 500, width: 40 }}>{index + 1}</td>
                                                        <td style={{ padding: '8px 12px', verticalAlign: 'top' }}>
                                                            <Form.Item
                                                                name={['installmentAmounts', index]}
                                                                style={{ marginBottom: 0 }}
                                                                rules={[{ required: true, message: `Required` }]}
                                                            >
                                                                <Input type="number" min={0} step="0.01" placeholder="Standard amount" />
                                                            </Form.Item>
                                                        </td>
                                                        <td style={{ padding: '8px 12px', verticalAlign: 'top' }}>
                                                            <Form.Item
                                                                name={['alumniInstallmentAmounts', index]}
                                                                style={{ marginBottom: 0 }}
                                                            >
                                                                <Input type="number" min={0} step="0.01" placeholder="Alumni amount" />
                                                            </Form.Item>
                                                        </td>
                                                        <td style={{ padding: '8px 12px', verticalAlign: 'top' }}>
                                                            <Form.Item
                                                                name={['installmentDueDate', index]}
                                                                style={{ marginBottom: 0 }}
                                                            >
                                                                <Input type="date" />
                                                            </Form.Item>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                )}

                                <Form.Item
                                    name='isShowOnHome'
                                    label="Show on Home Page"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please select course's show on home page status",
                                        },
                                    ]}
                                >
                                    <Select
                                        placeholder="Please select course's show on home page status"
                                    >
                                        <Option value="true">Yes</Option>
                                        <Option value="false">No</Option>
                                    </Select>
                                </Form.Item>

                                <Form.Item
                                    name='description1'
                                    label="Description 1"
                                >
                                    <ReactQuill
                                        modules={modules}
                                        theme="snow"
                                        placeholder="Please enter course's description"
                                        style={{ height: '200px', marginBottom: '50px' }}
                                    />
                                </Form.Item>

                                <Form.Item
                                    name='whatsappGroupLink'
                                    label="Whatsapp Group Link"
                                >
                                    <Input
                                        placeholder='Please enter whatsapp group link'
                                    />
                                </Form.Item>

                                <Form.Item
                                    name='videoUrl'
                                    label="Video URL"
                                >
                                    <Input
                                        placeholder='Please enter video url'
                                    />
                                </Form.Item>

                                <Form.Item
                                    name='coordinatorId'
                                    label="Assign Coordinator"
                                >
                                    <Select
                                        placeholder="Select a coordinator user"
                                        allowClear
                                        showSearch
                                        optionFilterProp="children"
                                        onChange={(value) => {
                                            if (value) {
                                                const coord = coordinators.find(c => c.id === value);
                                                if (coord) {
                                                    form.setFieldsValue({
                                                        coordinatorName: coord.name,
                                                        coordinatorWhatsApp: coord.contactNumber
                                                    });
                                                }
                                            } else {
                                                form.setFieldsValue({
                                                    coordinatorName: undefined,
                                                    coordinatorWhatsApp: undefined
                                                });
                                            }
                                        }}
                                    >
                                        {coordinators.map(coord => (
                                            <Option key={coord.id} value={coord.id}>
                                                {coord.name} ({coord.email})
                                            </Option>
                                        ))}
                                    </Select>
                                </Form.Item>

                                <Form.Item
                                    name='coordinatorName'
                                    label="Coordinator Name"
                                >
                                    <Input
                                        placeholder='Please enter coordinator name'
                                    />
                                </Form.Item>

                                <Form.Item
                                    name='coordinatorWhatsApp'
                                    label="Coordinator WhatsApp Number"
                                >
                                    <Input
                                        placeholder='Please enter coordinator whatsapp number'
                                    />
                                </Form.Item>

                                <Form.Item
                                    name="isPublished"
                                    label="Course is Published"
                                >
                                    <Select
                                        placeholder="Please select course's published status"
                                    >
                                        <Option value="true">Published</Option>
                                        <Option value="false">Not Published</Option>
                                    </Select>
                                </Form.Item>
                                <Form.Item
                                    name='isAppearOnHome'
                                    label="Appear on Home"
                                >
                                    <Select
                                        placeholder="Please select course's appear on home status"
                                    >
                                        <Option value="true">Appear on Home</Option>
                                        <Option value="false">Don't Appear on Home</Option>
                                    </Select>
                                </Form.Item>

                                <Form.Item
                                    name='status'
                                    label="Course Status"
                                >
                                    <Select
                                        placeholder="Please select course's status"
                                    >
                                        <Option value="ongoing">Ongoing</Option>
                                        <Option value="completed">Completed</Option>
                                    </Select>
                                </Form.Item>


                                <Row gutter={16}>
                                    <Col span={24}>
                                        <Button
                                            style={{ width: '100%' }}
                                            type="primary" htmlType="submit">
                                            Update Course
                                        </Button>
                                    </Col>
                                </Row>
                            </Form>
                        </div>
                    </div>
                    )}
                    <div className='edit-right' style={{ width: userProfile?.role === 'coordinator' ? '100%' : '50%' }}>
                        <div className='top'>
                            <h2>Course Content</h2>
                            <Button
                                onClick={showAddContent}
                                type='primary'><PlusOutlined /> Add Content</Button>
                        </div>
                        <div className='content'>
                            <List
                                size="small"
                                bordered
                                dataSource={data}
                                renderItem={item =>
                                    <List.Item
                                        style={{
                                            flexDirection: 'column',
                                        }}
                                    >
                                        <Row
                                            gutter={16}
                                        >
                                            <div className='no-edit'>
                                                <section>
                                                    <p>Content Title:</p>
                                                    <span>
                                                        {item.title || 'N/A'}
                                                    </span>
                                                </section>
                                                <section>
                                                    <p>Description:</p>
                                                    <span
                                                        className="ql-editor"
                                                        style={{ padding: 0 }}
                                                        dangerouslySetInnerHTML={{ __html: item.description || 'N/A' }}
                                                    />
                                                </section>
                                                <section>
                                                    <p>Video ID:</p>
                                                    <span>
                                                        {item.videoUrl || 'N/A'}
                                                    </span>
                                                </section>
                                                <section>
                                                    <p>Drive URL:</p>
                                                    <span>
                                                        {(() => {
                                                            const formatted = formatDriveUrl(item.driveUrl);
                                                            return formatted ? (
                                                                <a href={formatted.directUrl} target="_blank" rel="noopener noreferrer" style={{ color: '#1890ff', wordBreak: 'break-all' }}>
                                                                    {formatted.directUrl}
                                                                </a>
                                                            ) : (
                                                                'N/A'
                                                            );
                                                        })()}
                                                    </span>
                                                </section>

                                                <section>
                                                    <p>Created At:</p>
                                                    <span>
                                                        {item.createdAt ? new Date(item.createdAt).toDateString() : 'N/A'}
                                                    </span>
                                                </section>
                                                <section>
                                                    <p>Is Free:</p>
                                                    <span
                                                        style={{
                                                            color: item.isFree ? 'green' : 'red'
                                                        }}
                                                    >
                                                        {item.isFree ?
                                                            'Free'
                                                            : 'Paid'}
                                                    </span>
                                                </section>
                                                <section>
                                                    <p>Is Published:</p>
                                                    <span
                                                        style={{
                                                            color: item.isPublished ? 'green' : 'red'
                                                        }}
                                                    >
                                                        {item.isPublished ?
                                                            'Published'
                                                            : 'Not Published'}
                                                    </span>
                                                </section>
                                            </div>
                                        </Row>

                                        <Row
                                            gutter={16}
                                        >
                                            <Col>
                                                <Button
                                                    onClick={
                                                        () => {
                                                            setOpenEdit(true);
                                                            setSelectedContentId(item.id);
                                                        }
                                                    }
                                                    style={{ width: '100%' }}
                                                    type="default"
                                                >
                                                    Edit
                                                </Button>
                                            </Col>

                                            <Col >
                                                <Popconfirm
                                                    title="Delete the content."
                                                    description="This action cannot be undone. Are you sure you want to delete this content?"
                                                    onConfirm={deleteContent.bind(this, item.id)}
                                                    okText="Yes"
                                                    cancelText="No"
                                                >
                                                    <Button
                                                        style={{ width: '100%' }}
                                                        type="default"
                                                        danger>
                                                        <DeleteOutlined />
                                                        Delete
                                                    </Button>
                                                </Popconfirm>
                                            </Col>
                                        </Row>
                                    </List.Item>
                                }
                            />
                        </div>
                    </div>
                </div>
            </Spin>

            <AddContent
                isOpen={isAddContentOpen}
                setOpen={setisAddContentOpen}
                courseId={courseId}
                hadleGetCourceContents={getCourseContents}
            />

            <EditContent
                isOpen={openEdit}
                setOpen={setOpenEdit}
                contentData={selectedContentData}
                courseId={courseId}
                hadleGetCourceContents={getCourseContents}
            />
        </div>
    )
}

export default EditCourse